module.exports = __webpack_public_path__ + "img/layanan_transportasi.39fa6b53.png";